import { AnalyticsArea, useAnalyticsEventTracker } from 'hooks'
import React from 'react'
import { OverviewProps } from './overview-wrapper'
import MobileProductExposure from './pages/exposure-mobile'
import InTheNumbersMobileComponent from './pages/number-container/mobile'
import SmartProductsMobile from './pages/smart-products/mobile'
import SplashComponentMobile from './pages/splash/mobile'
import {
  BannerContentWrapper,
  BannerTagLine,
  BannerTextWrapper,
  BannerTitle,
  FullWidthBannerWrapperMobile,
  MobileOverviewContainer,
  IndexLogo,
  TwitterLogo,
  WhitePaperContainerMobile,
  WhitePaperContentWrapper,
  WhitePaperDescription,
  WhitePaperTitleMobile,
  WhitepaperButton,
  PartnersBlockContentWrapper,
  StyledWhaleImage,
  StyledPoweredTitle,
  PoweredTitleWrapper,
  DashedLineImage,
  PartnersWrapper,
  PartnerItem,
  PartnerLogo,
  PartnerName,
  PartnersBottomText,
} from './styled'
import ARTXIcon from 'assets/assets-list/artx-ai-icon.png'
import POWERED_BANNER from 'assets/overview/powered-whale-logo.png'
import DASHED_LINE from 'assets/overview/dashed-line-mobile.png'
import { partnersList } from './service'

const MobileOverview: React.FC<OverviewProps> = ({ overviewProducts: productData }) => {
  const { navigationEvent } = useAnalyticsEventTracker(AnalyticsArea.Overview)
  const downloadWhitePaper = () => {
    window.open('/phuture-v2-core.pdf', '_blank')
  }

  return (
    <MobileOverviewContainer>
      <SplashComponentMobile />
      <FullWidthBannerWrapperMobile showIndex onClick={() => navigationEvent('/products/artxai')}>
        <BannerContentWrapper>
          <IndexLogo src={ARTXIcon} />
          <BannerTextWrapper>
            <BannerTitle>ARTX AI Smart Fund</BannerTitle>
            <BannerTagLine>AI-powered fund exposed to megacaps </BannerTagLine>
          </BannerTextWrapper>
        </BannerContentWrapper>
      </FullWidthBannerWrapperMobile>
      <MobileProductExposure products={productData} />
      <WhitePaperContainerMobile>
        <WhitePaperContentWrapper>
          <WhitePaperTitleMobile>
            Phuture 2.0 —<br /> <i>borderless</i> crypto investing
          </WhitePaperTitleMobile>
          <WhitePaperDescription>
            With Phuture 2.0, you can invest in index funds that include assets across the most
            popular networks
          </WhitePaperDescription>
          <WhitepaperButton buttonType="light-secondary" onClick={downloadWhitePaper}>
            View whitepaper
          </WhitepaperButton>
        </WhitePaperContentWrapper>
      </WhitePaperContainerMobile>
      <PartnersBlockContentWrapper>
        <PoweredTitleWrapper>
          <StyledWhaleImage src={POWERED_BANNER} />
          <StyledPoweredTitle>Powered by Phuture</StyledPoweredTitle>
        </PoweredTitleWrapper>
        <DashedLineImage src={DASHED_LINE} />
        <PartnersWrapper>
          {partnersList.map(({ name, icon, link }) => (
            <PartnerItem key={`${name}-partner`} onClick={() => navigationEvent(link, true)}>
              <PartnerLogo src={icon} />
              <PartnerName>{name}</PartnerName>
            </PartnerItem>
          ))}
        </PartnersWrapper>
        <PartnersBottomText>
          Phuture’s asset management platform is powering some of the biggest Web3 index products.
        </PartnersBottomText>
      </PartnersBlockContentWrapper>
      <SmartProductsMobile />
      <FullWidthBannerWrapperMobile
        showIndex={false}
        onClick={() => navigationEvent('https://twitter.com/phuture_finance', true)}
      >
        <BannerContentWrapper>
          <TwitterLogo />
          <BannerTextWrapper>
            <BannerTitle>Follow us on Twitter</BannerTitle>
            <BannerTagLine>@phuture_finance</BannerTagLine>
          </BannerTextWrapper>
        </BannerContentWrapper>
      </FullWidthBannerWrapperMobile>
      <InTheNumbersMobileComponent />
    </MobileOverviewContainer>
  )
}
export default MobileOverview
